import React from 'react';
import styled from 'styled-components';
import MainIndexCounts from 'components/MainIndexCounts';
import Enquiry from '../Enquiry';
import Process from '../Process';
const ProcessIndex = () => {
    return (
        <Container>
            <MainIndexCounts />
            <Enquiry onlyTable />
            <Process onlyTable />

        </Container>
    );
};

export default ProcessIndex;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;
